<template>
  <div class="third-sdk-contain">
    <div>
      <p style="margin-top:0pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span class="h0-title" style="font-family:'微软雅黑'; font-weight:bold">
          一部手机管旅游App第三方信息共享清单
        </span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          更新日期：2026年4月24日
        </span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          生效日期：2026年4月30日
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          一、第三方合作服务共享说明
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          为保障部分独立功能的实现，使您能够使用和享受更丰富的服务与功能，我们会在应用中嵌入第三方的SDK，并对其使用目的进行审慎评估。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          请您理解，第三方SDK的功能和服务处于持续更新和演进之中，其所处理的数据类型等内容可能因功能调整或策略变化而发生变动，具体请以第三方在其官方平台公示的有关个人信息处理规则为准。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          此外，为保障特定功能的实现，使您能够使用和享受更完善的服务与功能，我们会在特定场景下向第三方共享您的信息，并将严格审慎评估此类信息共享的必要性。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （1）腾讯Bugly崩溃分析
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          用户使用中发生崩溃时
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          收集应用崩溃问题，保障APP稳定性
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（Android ID、设备型号、系统版本、品牌、CPU架构、名称、IDFV、手机参数），存储信息（读取外部存储、写入外部存储），访问网络信息(IP地址)，访问WiFi网络信息(WiFi状态)）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑'">
          深圳市腾讯计算机系统有限公司
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          https://bugly.qq.com/v2/
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <span style="font-family:'Times New Roman'; background-color:#ffffff">
          https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'; font-weight:bold">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （2）腾讯TBS浏览服务SDK
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          用户浏览应用内页面时
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          为用户提供应用内页面浏览能力
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（Android ID、设备型号、系统版本、品牌、CPU架构、名称、IDFV、设备系统构建），存储信息（读取外部存储，写入外部存储），应用信息（应用包名、应用版本号、运行状态），网络类型（3G、4G、5G、WiFi），访问网络信息(IP地址)，访问WiFi网络信息(WiFi状态)
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          腾讯TBS浏览服务SDK在前台静默和后台静默期间，可能会获取IP地址、设备系统构建信息、WiFi网络信息、读取外部存储文件，写入外部存储文件，约一分钟收集一次，用于为用户提供一部手机管旅游平台页面浏览服务。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑'">
          深圳市腾讯计算机系统有限公司
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          https://x5.tencent.com/
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'; font-weight:bold">
          SDK
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          隐私政策：
        </span>
        <span style="font-family:'Times New Roman'">
          https://x5.tencent.com/docs.html#202403280001
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'; font-weight:bold">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （3）腾讯地图SDK
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          用户使用地图及定位相关服务时
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的
        </span>
        <span style="font-family:'微软雅黑'">
          ：为管理部门用户录入购物点时提供
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          购物店位置
        </span>
        <span style="font-family:'微软雅黑'">
          信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（Android ID、IDFV、OAID、系统属性、操作系统及版本、手机屏幕密度和尺寸、操作系统及版本、系统设置、设备型号、读取手机状态、Sim卡状态、设备运动数据、剪切板），
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置信息（获取近似位置、获取精确位置
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          、
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          获取基站信息
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          ）
        </span>
        <span style="font-family:'微软雅黑'">
          ，存储信息（读取外部存储、写入外部存储），网络类型（3G、4G、5G、WiFi），访问网络信息(Cell ID、IP地址)，访问Wi-Fi网络信息(WiFi状态、WiFi参数、附近的WiFi列表、连接的WiFi、SSID、BSSID)、蓝牙信息），传感器信息（重力传感器、陀螺仪传感器 、加速度传感器 、磁场传感器 、旋转矢量传感器），电话权限，网络运营商名称，手机制式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          和地图强相关的场景，包括
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          购物店位置定位
        </span>
        <span style="font-family:'微软雅黑'">
          服务，在开启定位并在您同意授权获取定位时，会获取您的
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          实时位置
        </span>
        <span style="font-family:'微软雅黑'">
          。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          腾讯地图SDK在前台静默和后台静默期间，可能会获取IP地址、WiFi网络信息、
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置信息（获取精确位置，获取近似位置
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          、
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          获取基站信息
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          ）
        </span>
        <span style="font-family:'微软雅黑'">
          ，读取外部存储文件，写入外部存储文件，约一分钟收集一次，用于当用户使用定位功能，在移动终端设备向用户提供定位信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑'">
          深圳市腾讯计算机系统有限公司
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          https://lbs.qq.com/
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <span style="font-family:'Times New Roman'">
          https://privacy.qq.com/document/preview/a10a8634f237464da9a95f4f07e73e40
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （4）腾讯定位SDK
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          用户使用地图及定位相关服务时
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的
        </span>
        <span style="font-family:'微软雅黑'">
          ：为用户提供地图服务、出行服务、周边内容展示
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（Android ID、IDFV、OAID、系统属性、操作系统及版本、手机屏幕密度和尺寸、操作系统及版本、系统设置、设备型号、读取手机状态、Sim卡状态、设备运动数据、剪切板），
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置信息（获取近似位置、获取精确位置
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          、
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          获取基站信息
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          ）
        </span>
        <span style="font-family:'微软雅黑'">
          ，存储信息（读取外部存储、写入外部存储），网络类型（3G、4G、5G、WiFi），访问网络信息(Cell ID、IP地址)，访问Wi-Fi网络信息(WiFi状态、WiFi参数、附近的WiFi列表、连接的WiFi、SSID、BSSID)、蓝牙信息），传感器信息（重力传感器、陀螺仪传感器 、加速度传感器 、磁场传感器 、旋转矢量传感器），电话权限，网络运营商名称，手机制式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          和地图强相关的场景，包括
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          购物店位置定位
        </span>
        <span style="font-family:'微软雅黑'">
          服务，在开启定位并在您同意授权获取定位时，会获取您的
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          实时位置
        </span>
        <span style="font-family:'微软雅黑'">
          。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          腾讯定位SDK在前台静默和后台静默期间，可能会获取IP地址、
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置信息（获取精确位置，获取近似位置
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          、
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          获取基站信息
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          ）
        </span>
        <span style="font-family:'微软雅黑'">
          ，WiFi网络信息、读取外部存储文件，写入外部存储文件，约一分钟收集一次，用于当用户使用定位功能，在移动终端设备向用户提供定位信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑'">
          深圳市腾讯计算机系统有限公司
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          https://lbs.qq.com/
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <span style="font-family:'Times New Roman'">
          https://privacy.qq.com/document/preview/dbd484ce652c486cb6d7e43ef12cefb0
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （5）腾讯MTP反外挂SDK
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          安全加固
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          应用安全加固，提升应用安全性
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（Android ID、设备型号、系统版本、品牌、CPU架构、频率、SIM卡MCC/MNC、名称、IDFV），存储信息（读取外部存储文件、写入外部存储文件），应用信息（应用包名、应用版本号、运行状态），网络信息（访问网络(3G、4G、5G、WiFi)，访问网络信息(IP地址)，访问WiFi网络信息(WiFi状态，WiFi名称)）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          腾讯MTP反外挂SDK在前台静默和后台静默期间，可能会获取IP地址，WiFi网络信息、读取外部存储文件，约一分钟收集一次，用于用户使用一部手机管旅游时安全加固，提升应用安全性
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑'">
          深圳市腾讯计算机系统有限公司
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <a href="https://www.anticheatexpert.com/#/doc-center/47019c9bb902d424632782311957ec29073f3ec4"
          style="text-decoration:none">
          <span style="font-family:'Times New Roman'; color:#000000">
            https://www.anticheatexpert.com/#/doc-center/47019c9bb902d424632782311957ec29073f3ec4
          </span>
        </a>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <a href="https://www.anticheatexpert.com/#/doc-center/8fc4c1195346a2c74e472881bca42c4010698921"
          style="text-decoration:none">
          <span style="font-family:'Times New Roman'; color:#000000">
            https://www.anticheatexpert.com/#/doc-center/8fc4c1195346a2c74e472881bca42c4010698921
          </span>
        </a>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （6）腾讯灯塔Beacon SDK
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          数据分析
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          提高数据链路时效性和准确性
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（Android ID，MAC地址，IMSI，IMEI，设备型号，语言、时区、读取手机状态，陀螺仪传感器、设备系统构建），存储信息（读取外部存储），应用信息（应用包名、应用版本号、运行状态），网络类型（3G、4G、5G、WiFi），访问网络信息(IP地址)，访问WiFi网络信息(WiFi状态)）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          腾讯灯塔BeaconSDK在前台静默和后台静默期间，可能会获取IP地址，WiFi网络信息，读取外部存储文件，约一分钟收集一次，用于当用户使用数据可视化功能时，在移动终端设备向用户提供数据可视化分析服务
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑'">
          深圳市腾讯计算机系统有限公司
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <a href="https://cloud.tencent.com/document/product/1558" style="text-decoration:none">
          <span style="font-family:'Times New Roman'; color:#000000">
            https://cloud.tencent.com/document/product/1558
          </span>
        </a>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <span style="font-family:'Times New Roman'">
          https://privacy.qq.com/document/preview/a19a8cf4f2354306b137a7db39d32024
        </span>
      </p>
      <p style="margin-top:3pt; margin-bottom:3pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （7）腾讯云COS文件上传服务
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          用户上传图片或文件时
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          提供文件上传及浏览能力
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（Android ID）存储信息（读取外部存储，写入外部存储）网络类型（3G、4G、5G、WiFi），访问网络信息(IP地址)，访问WiFi网络信息(WiFi状态) ）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑'">
          深圳市腾讯计算机系统有限公司
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <a href="https://cloud.tencent.com/product/cos" style="text-decoration:none">
          <span style="font-family:'Times New Roman'; text-decoration:underline; color:#0563c1">
            https://cloud.tencent.com/product/cos
          </span>
        </a>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <a href="https://privacy.qq.com/document/preview/a76038ae5ee242d18d3a45a34cdd744c" style="text-decoration:none">
          <span style="font-family:'Times New Roman'; text-decoration:underline; color:#0563c1">
            https://privacy.qq.com/document/preview/a76038ae5ee242d18d3a45a34cdd744c
          </span>
        </a>
      </p>
      <p style="margin-top:3pt; margin-bottom:3pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          
        </span>
        <span style="font-family:'Times New Roman'; font-weight:bold">
          
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （8）腾讯QIMEI SDK
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          数据分析
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          提高数据链路时效性和准确性
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（Android ID，MAC地址，IMSI，IMEI，设备型号，读取手机状态，设备系统构建信息），存储信息（读取外部存储），应用信息（应用包名、应用版本号、运行状态），网络类型（3G、4G、5G、WiFi），访问网络信息(IP地址)，访问WiFi网络信息(WiFi状态)）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑'">
          深圳市腾讯计算机系统有限公司
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <span style="font-family:'Times New Roman'">
          https://privacy.qq.com/document/preview/91754d6dd7824e3689f17782c580e06e
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'; font-weight:bold">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （9）移动推送TPNS SDK
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          推送消息时使用
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          在移动终端设备进行消息推送
        </span>
        <span style="width:15pt; display:inline-block">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
        <span style="width:3pt; display:inline-block">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息(厂商、机型、国家编码、系统版本、系统语言、手机型号、内核参数、SDCard信息、Android ID、OAID、IDFV)，存储信息（读取外部存储，写入外部存储），网络类型（3G、4G、5G、WiFi），访问网络信息(IP地址、运营商代号)，账号绑定信息(QQopenID、微信Union ID、 手机号)，访问WiFi网络信息(WiFi状态)）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          腾讯 移动推送TPNS SDK在前台静默和后台静默期间，可能会获取OAID、IDFV、IP地址、WiFi网络信息、读取外部存储文件，约30秒收集一次，用于用户使用一部手机管旅游时接收业务办理消息推送，提醒用户及时完成业务处理
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑'">
          深圳市腾讯计算机系统有限公司
        </span>
        <span style="font-family:'Times New Roman'">
          https://cloud.tencent.com/product/tpns
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <span style="font-family:'Times New Roman'">
          https://privacy.qq.com/document/preview/8565a4a2d26e480187ed86b0cc81d727
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'; font-weight:bold">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （10）华为推送SDK
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          推送消息时使用
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          为用户提供通知信息推送功能
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
        <span style="width:3pt; display:inline-block">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（Android ID，应用列表，获取任务信息，读取手机状态），存储信息（读取外部存储，写入外部存储）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑'">
          华为软件技术有限公司
        </span>
        <span style="font-family:'Times New Roman'">
          https://developer.huawei.com/consumer/cn/hms/huawei-pushkit
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
         SDK隐私政策：
        </span>
        <a href="https://consumer.huawei.com/cn/privacy/privacy-policy/" style="text-decoration:none">
          <span
            style="font-family:'Times New Roman'; text-decoration:underline; color:#0563c1; background-color:#ffffff">
            https://consumer.huawei.com/cn/privacy/privacy-policy/
          </span>
        </a>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'; font-weight:bold">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （11）Fresco框架
        </span>
        <span style="width:16.35pt; display:inline-block">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          用户浏览图片时
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          提供网络图片加载能力
        </span>
        <span style="width:9pt; display:inline-block">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
        <span style="width:3pt; display:inline-block">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（Android ID），存储信息（读取外部存储，写入外部存储），网络信息（访问网络(3G、4G、5G、WiFi)，访问网络信息(IP地址)，访问WiFi网络信息(WiFi状态)）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'Times New Roman'">
          Fresco
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          https://frescolib.org/
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：暂无
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'; font-weight:bold">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （12）ApacheHTTPclient支持jar包
        </span>
        <span style="width:10.35pt; display:inline-block">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          用户下载文件时
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          提供网络框架支撑能力
        </span>
        <span style="width:9pt; display:inline-block">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
        <span style="width:3pt; display:inline-block">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（Android ID），存储信息（读取外部存储）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'Times New Roman'">
          Apache
        </span>
        <a href="http://www.apache.org/" style="text-decoration:none">
          <span style="font-family:'Times New Roman'; text-decoration:underline; color:#0563c1">
            http://www.apache.org/
          </span>
        </a>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <span style="font-family:'Times New Roman'">
          https://privacy.apache.org/policies/privacy-policy-public.html
        </span>
      </p>
      <p style="margin-top:3pt; margin-bottom:3pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'; color:#333333">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （13）Android开发工具库
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          应用开发工具
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          对Android系统提供标准新功能支持，使开发者能更轻松地面向更多设备进行开发和提供支持
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（IMEI，Android ID，应用软件列表），
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置信息
        </span>
        <span style="font-family:'微软雅黑'">
          （获取
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          精确位置
        </span>
        <span style="font-family:'微软雅黑'">
          ，获取
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          近似位置
        </span>
        <span style="font-family:'微软雅黑'">
          ），权限信息（
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置权限
        </span>
        <span style="font-family:'微软雅黑'">
          ，相机权限，存储权限），存储信息（读取外部存储文件，写入外部存储文件）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'Times New Roman'">
          Google
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <a href="https://developer.android.google.cn/" style="text-decoration:none">
          <span style="font-family:'Times New Roman'; text-decoration:underline; color:#0563c1">
            https://developer.android.google.cn/
          </span>
        </a>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <a href="https://developer.android.google.cn/privacy" style="text-decoration:none">
          <span style="font-family:'Times New Roman'; text-decoration:underline; color:#0563c1">
            https://developer.android.google.cn/privacy
          </span>
        </a>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （14）AndroidUtilCode
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          应用开发工具
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          通过封装常用功能帮助开发者提高开发效率，降低出错概率
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（IMEI，Android ID，应用软件列表），存储信息（读取外部存储文件，写入外部存储文件），应用信息（应用包名、应用版本号、运行状态）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑'">
          Blankj（GitHub用户名）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <a href="https://github.com/Blankj/AndroidUtilCode" style="text-decoration:none">
          <span style="font-family:'Times New Roman'; text-decoration:underline; color:#0563c1">
            https://github.com/Blankj/AndroidUtilCode
          </span>
        </a>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <span style="font-family:'微软雅黑'">
          暂无
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （15）Flutter
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          用户进行投诉处置操作时
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          提升应用的流畅度并实现优美的动画效果
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（IMEI，Android ID，OAID，应用软件列表），
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置信息（获取精确位置，获取近似位置）
        </span>
        <span style="font-family:'微软雅黑'">
          ，权限信息（
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置权限
        </span>
        <span style="font-family:'微软雅黑'">
          ，相机权限，存储权限），存储信息（读取外部存储文件，写入外部存储文件）、剪切板
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑' ">
          Google
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <a href="https://flutter.dev/" style="text-decoration:none">
          <span style="font-family:'Times New Roman'; text-decoration:underline; color:#0563c1">
            https://flutter.dev/
          </span>
        </a>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <span style="font-family:'微软雅黑'">
          暂无
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （16）Sentry
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          用户使用中发生崩溃时
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          收集应用崩溃问题，保障APP稳定性
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（IDFA, IDFV，UUID，获取任务信息，读取手机状态），存储信息（读取外部存储，写入外部存储），应用信息（应用包名、应用版本号、运行状态），
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置信息（获取近似位置、获取精确位置）
        </span>
        <span style="font-family:'微软雅黑'">
          ，网络类型（3G、4G、5G、WiFi），访问网络信息(IP地址)，访问WiFi网络信息(WiFi状态)
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:''; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑'">
          Sentry
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          https://sentry.io/for/ios/?original_referrer=https%3A%2F%2Fwww.google.com%2F
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <a href="https://sentry.io/privacy/?original_referrer=https:/www.google.com/" style="text-decoration:none">
          <span style="font-family:'Times New Roman'; text-decoration:underline; color:#0563c1">
            https://sentry.io/privacy/?original_referrer=https://www.google.com/
          </span>
        </a>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'; font-weight:bold">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （17）webview浏览器
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          用户浏览网页时
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          提供网页浏览服务
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（IMEI，Android ID，应用软件列表），
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置信息（获取精确位置，获取近似位置），
        </span>
        <span style="font-family:'微软雅黑'">
          存储信息（读取外部存储文件，写入外部存储文件）、剪切板
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑'">
          谷歌
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <span style="font-family:'微软雅黑'">
          暂无
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （18）WebKit浏览器
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          用户浏览网页时
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          提供网页浏览服务
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（IDFV，设备类型），
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置信息（获取精确位置，获取近似位置）
        </span>
        <span style="font-family:'微软雅黑'">
          ，存储信息（读取外部存储文件，写入外部存储文件）、剪切板
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑'">
          苹果
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          https://webkit.org/
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <span style="font-family:'微软雅黑'">
          暂无
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （19）EasyImage
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用场景：
        </span>
        <span style="font-family:'微软雅黑'">
          用户使用相册、相机时
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          实现Android应用中的拍照、选取图片等功能
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          处理方式：
        </span>
        <span style="font-family:'微软雅黑'">
          采用去标识化、加密传输和处理的安全处理方式
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集个人信息字段：
        </span>
        <span style="font-family:'微软雅黑'">
          设备信息（应用软件列表）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          收集方式：
        </span>
        <span style="font-family:'微软雅黑'">
          SDK自主收集
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK提供主体：
        </span>
        <span style="font-family:'微软雅黑'">
          Jacek Kwiecień（GitHub用户名jkwiecien ）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          https://github.com/jkwiecien/EasyImage
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          SDK隐私政策：
        </span>
        <span style="font-family:'微软雅黑'">
          暂无
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'Times New Roman'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          二、清单查询与更新
        </span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; color:#0f1115; background-color:#ffffff">
          本清单将在一部手机管旅游App“我的-设置-隐私说明-第三方信息共享清单” 路径展示，更新后将通过一部手机管旅游平台公告等方式通知用户，用户可随时查阅最新版本。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold; color:#0f1115; background-color:#ffffff">
          三、
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          如何联系我们
        </span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; color:#0f1115; background-color:#ffffff">
          客服电话：0871-68011179（工作日 9:00-18:00）
        </span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; color:#0f1115; background-color:#ffffff">
          客服邮箱：service@yntengyun.com
        </span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; color:#0f1115; background-color:#ffffff">
          邮寄地址：云南省昆明市西山区环城南路777号昆钢科技大厦6F
        </span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; color:#0f1115; background-color:#ffffff">
          个人信息保护专员邮箱：
        </span>
        <a href="mailto:kevinliu@yntengyun.com" style="text-decoration:none">
          <span style="font-family:'微软雅黑'; text-decoration:underline; color:#0563c1; background-color:#ffffff">
            kevinliu@yntengyun.com
          </span>
        </a>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; color:#0f1115; background-color:#ffffff">
          我们将在15个工作日内回复。如对我们的处理不满意，您可向网信部门、消费者保护协会投诉，或提起诉讼。
        </span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'等线'">
          &#xa0;
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [],
      authData: {}
    };
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {
    document.title = '第三方信息共享清单'
  },

  created() { },
  beforeCreate() {
    document.title = '第三方信息共享清单'
  }
};
</script>

<style scoped lang="less">
.third-sdk-contain {
  padding: 0 12px 20px;
  p {
    line-height: 1.5;
  }

  .weight-big {
    font-weight: 700 !important;
  }

  .h0-title {
    font-size: 16px;
    font-family: PingFangSC-Semibold, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    font-weight: 700;
    color: rgba(51, 51, 51, 1);
    line-height: 14px;
    margin-top: 24px;
  }

  .content {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 22px;
    margin-top: 12px;

    a {
      color: blue;
    }
  }

  .content-box {
    .h1-title {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 14px;
      margin-top: 16px;
    }

    .h1-box {
      .h2-title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 22px;
        margin-top: 12px;
      }

      .h2-content {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 22px;
        margin-top: 12px;
      }
    }
  }
}
</style>
